import { render, staticRenderFns } from "./ChangeReseller.vue?vue&type=template&id=7b077496&"
import script from "./ChangeReseller.vue?vue&type=script&lang=js&"
export * from "./ChangeReseller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports